<template>
  <div class="mb-4 w-full">
    <div class="flex justify-between">
      <label
        :for="`${membershipUuid}_phoneNumber_${index}`"
        v-text="'Phone Number'"
      />
      <div class="flex mb-2">
        <button
          type="button"
          class="link-plain text-xs mr-1"
          @click.prevent="$emit('add')"
          v-text="'Add another'"
        />
        <button
          v-if="canRemovePhoneNumber"
          type="button"
          class="link-plain text-xs"
          @click.prevent="$emit('remove')"
          v-text="'Remove'"
        />
      </div>
    </div>
    <VuePhoneNumberInput
      :id="`${membershipUuid}_phoneNumber_${index}`"
      :value="phoneNumber.phone_number"
      color="#064bc3"
      class="mb-3"
      :class="{ 'error': errors.has(`phone_numbers.${index}.phone_number`) }"
      :translations="{ phoneNumberLabel: 'Phone Number' }"
      :default-country-code="phoneNumber.phone_number_country || defaultCountry"
      no-flags
      no-validator-state
      @update="handlePhoneUpdate"
    />
    <div class="field__meta">
      <span
        v-if="errors.has(`phone_numbers.${index}.phone_number`)"
        class="mb-3 field__meta__help"
        v-text="errors.get(`phone_numbers.${index}.phone_number`)"
      />
      <div class="flex">
        <AppCheckboxInput
          :id="`${membershipUuid}_phoneNumber_${index}_receives_sms`"
          v-model="phoneNumber.receives_sms"
          :name="`${membershipUuid}_phoneNumber_${index}_receives_sms`"
          label="Receives Text Messages?"
          container-classes="mr-2 field__meta__share"
        />
        <AppCheckboxInput
          v-if="profileSharingIsEnabled"
          :id="`${membershipUuid}_phoneNumber_${index}_is_visible`"
          v-model="phoneNumber.is_visible"
          :name="`${membershipUuid}_phoneNumber_${index}_is_visible`"
          label="Visible?"
          container-classes="field__meta__share"
        />
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
import HasErrors from 'Base/Resources/assets/js/mixins/has-errors'
import AppCheckboxInput from 'Base/Resources/assets/js/components/forms/inputs/AppCheckboxInput'

export default {
  name: 'PhoneNumberForm',
  components: {
    AppCheckboxInput,
    VuePhoneNumberInput,
  },
  mixins: [HasErrors],
  props: {
    value: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    membershipUuid: {
      type: String,
      required: false,
      default: 'member',
    },
    profileSharingIsEnabled: {
      type: Boolean,
      required: true,
    },
    canRemovePhoneNumber: {
      type: Boolean,
      required: true,
    },
    defaultCountry: {
      type: String,
      required: true,
    },
  },
  computed: {
    phoneNumber() {
      return this.value
    },
  },
  methods: {
    handlePhoneUpdate(value) {
      this.$emit('input', {
        ...this.phoneNumber,
        phone_number: value.phoneNumber,
        phone_number_country: value.countryCode,
      })
    },
  },
}
</script>
